import React, { useState } from "react";
import { Link } from "react-router-dom";
import useProductTags from "../../hooks/useProductTags";

type ProductsNavProps = {
  active: boolean;
  toggleNav: () => void;
};
const ProductsNav: React.FC<ProductsNavProps> = ({ active, toggleNav }) => {
  const [activeTag, setActiveTag] = useState<string | undefined>();
  const { result: productsTags } = useProductTags();
  if (!productsTags) {
    return null;
  }

  // Helper function to check if a category has any active tags after filtering out "0" tags
  const hasActiveTags = (categoryTags: any) => {
    return Object.entries(categoryTags).some(([secondaryTag, tertiaryTags]) => {
      if (secondaryTag === "0") return false;
      // Check if there are any non-"0" tertiary tags after filtering
      const filteredTertiaryTags = Array.isArray(tertiaryTags)
        ? tertiaryTags.filter((tag) => tag !== "0")
        : [];
      return filteredTertiaryTags.length > 0;
    });
  };

  // Filter main categories to only show those with active tags
  const activeCategories = Object.keys(productsTags).filter((tag) => {
    if (tag === "0") return false;
    return hasActiveTags(productsTags[tag]);
  });

  return (
    <div className={`products_menu ${active ? "d-flex" : "d-none"}`}>
      <ul>
        {activeCategories.map((tag) => (
          <li
            key={tag}
            className={`animate_all ${activeTag === tag && "active"}`}
            data-id={tag}
            onMouseEnter={(ev) => {
              const id = ev.currentTarget.dataset.id;
              setActiveTag(id);
            }}
          >
            <Link
              to={`/productos/${replaceWords(tag)}`}
              onClick={toggleNav}
              className="d-flex justify-content-between align-items-center"
            >
              {tag} <i className="fas fa-chevron-right"></i>
            </Link>
          </li>
        ))}
      </ul>
      <div className="menu_items">
        {activeTag &&
          activeTag !== "0" &&
          Object.entries(productsTags[activeTag])
            .filter(([secondaryTag, tertiaryTags]) => {
              // Filter out secondary tags that are "0" or have no active tertiary tags
              if (secondaryTag === "0") return false;
              // Check if there are any non-"0" tertiary tags after filtering
              const filteredTertiaryTags = Array.isArray(tertiaryTags)
                ? tertiaryTags.filter((tag) => tag !== "0")
                : [];
              return filteredTertiaryTags.length > 0;
            })
            .map(([secondaryTag, tertiaryTags]) => (
              <div className="childs" key={`menu_2_${secondaryTag}`}>
                <Link
                  to={`/productos/${replaceWords(activeTag)}/${replaceWords(
                    secondaryTag
                  )}`}
                  onClick={toggleNav}
                >
                  {secondaryTag}
                </Link>
                {tertiaryTags.length ? (
                  <ul>
                    {tertiaryTags
                      .filter((tertiaryTag) => tertiaryTag !== "0")
                      .map((tertiaryTag) => (
                        <li key={`menu_3_${secondaryTag}_${tertiaryTag}`}>
                          <Link
                            to={`/productos/${replaceWords(
                              activeTag
                            )}/${replaceWords(secondaryTag)}/${replaceWords(
                              tertiaryTag
                            )}`}
                            onClick={toggleNav}
                          >
                            {tertiaryTag}
                          </Link>
                        </li>
                      ))}
                  </ul>
                ) : null}
              </div>
            ))}
      </div>
    </div>
  );
};

function replaceWords(word: string) {
  // word = word.split(" ").join("-");
  // word = encodeURIComponent(word);
  return word.replace("Ba%C3%B1o", "Bano");
}

export default ProductsNav;
